__turbopack_context__.v({
  "deliveryFullfillmentOption": "ProductAvailability-module-scss-module__eJixcW__deliveryFullfillmentOption",
  "fullfillmentMethods": "ProductAvailability-module-scss-module__eJixcW__fullfillmentMethods",
  "fullfillmentMethodsContainer": "ProductAvailability-module-scss-module__eJixcW__fullfillmentMethodsContainer",
  "fullfillmentOptionContent": "ProductAvailability-module-scss-module__eJixcW__fullfillmentOptionContent",
  "fullfillmentOptionDescription": "ProductAvailability-module-scss-module__eJixcW__fullfillmentOptionDescription",
  "fullfillmentOptionFlexContainer": "ProductAvailability-module-scss-module__eJixcW__fullfillmentOptionFlexContainer",
  "fullfillmentOptionTitle": "ProductAvailability-module-scss-module__eJixcW__fullfillmentOptionTitle",
  "high": "ProductAvailability-module-scss-module__eJixcW__high",
  "low": "ProductAvailability-module-scss-module__eJixcW__low",
  "medium": "ProductAvailability-module-scss-module__eJixcW__medium",
  "stockLevelContainer": "ProductAvailability-module-scss-module__eJixcW__stockLevelContainer",
  "stockLevelMessage": "ProductAvailability-module-scss-module__eJixcW__stockLevelMessage",
  "storeFullfillmentOption": "ProductAvailability-module-scss-module__eJixcW__storeFullfillmentOption",
});
